/**
 * Created by Administrator on 2017/6/3.
 */
export var localdata = {
    images: [
      'https://static.lecai.com/upload/resources/index/201509/1443077376677.jpg',
      'https://static.lecai.com/upload/resources/index/201704/1493281160156.jpg',
      'https://static.lecai.com/upload/resources/index/201704/1493359965791.jpg'
    ]
  };



// WEBPACK FOOTER //
// ./src/common/js/data.js